import { render, staticRenderFns } from "./user-bio-6.vue?vue&type=template&id=6f0fe62f"
import script from "./user-bio-6.vue?vue&type=script&lang=js"
export * from "./user-bio-6.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports